import { prepareInitialFilters } from './results-prefilters';
import { loadFiltersSlider, bindRangeInputs } from '../filters/sliderRange';
import { fetchMapResults, sendResultsFilters } from './results-api';
import { setMapData } from './results-state';
import { adjustColor } from './results-ui';
import { initMap } from '../../../../../../themes/custom/ev_theme/frontend/js/components/loadMap';
import { setdata } from './load';
import { getCardMap } from '../map';
export async function loadResultsData() {
    var _a, _b;
    window.rangeValue = 12;
    const appElement = document.getElementById('app');
    const data = JSON.parse(((_a = appElement === null || appElement === void 0 ? void 0 : appElement.dataset) === null || _a === void 0 ? void 0 : _a.projects) || '{}');
    if (document.getElementById('js-project-banner')) {
        (_b = document.getElementById('datos1')) === null || _b === void 0 ? void 0 : _b.classList.remove('d-none');
    }
    prepareInitialFilters(data);
    const sendData = await sendResultsFilters(false);
    setdata(sendData);
    requestAnimationFrame(() => {
        loadFiltersSlider('precio');
        loadFiltersSlider('area');
        bindRangeInputs('precio');
        bindRangeInputs('area');
        loadBannerBuilder();
    });
    loadMapDataAfterResults();
}
async function loadMapDataAfterResults() {
    try {
        const mapData = await fetchMapResults();
        setMapData(mapData);
        initMap();
        // foreach marker maps
        if (mapData.Items) {
            getCardMap(mapData);
        }
    }
    catch (error) {
        console.warn('No se pudo cargar la información del mapa', error);
    }
}
export function loadBannerBuilder() {
    let contentCards = document.querySelectorAll('.fair-card--builder');
    contentCards.forEach((card) => {
        const bannerBuilderFair = card.querySelector('.fair-card__banner--builder');
        if (bannerBuilderFair) {
            const baseColor = bannerBuilderFair.getAttribute('base-color');
            if (baseColor) {
                const adjustedColor = adjustColor(baseColor);
                bannerBuilderFair.style.background =
                    `linear-gradient(45deg, ${baseColor} 0%, ${adjustedColor} 100%)`;
            }
        }
    });
}
